//Reset data
export const RESET = "CONVERSATION_UPDATE_RESET"

export const SET_IS_UPDATED = "CONVERSATION_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "CONVERSATION_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "CONVERSATION_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CONVERSATION_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CONVERSATION_UPDATE_SET_HIDE_LOADING"

//Reload Conversation
export const SET_RELOAD_CONVERSATION = "CONVERSATION_UPDATE_SET_RELOAD_CONVERSATION"

//Message
export const SET_MESSAGE = "CONVERSATION_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "CONVERSATION_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CONVERSATION_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CONVERSATION_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CONVERSATION_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CONVERSATION_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "CONVERSATION_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "CONVERSATION_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CONVERSATION_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CONVERSATION_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CONVERSATION_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "CONVERSATION_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "CONVERSATION_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CONVERSATION_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CONVERSATION_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CONVERSATION_UPDATE_SET_MODAL_TYPE"